import React, { useEffect, useState } from "react";
import "./Transaction.css";

const Transaction = () => {
    const [transaction, settransaction] = useState([{
        to: "",
        from: "",
        amount: ""

    }]);


    useEffect(() => {
        fetch("https://basic-bank-app.herokuapp.com/transactiondata").then((res) => {
            if (res.ok) {
                return res.json();
            }
        }).then((jsonres) => settransaction(jsonres))
    })

    return (
        <>
            <div className="trans_container">
                <table>
                    <thead>
                        <tr>
                            <th>From</th>
                            <th>To</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>

                        {transaction.map((trans) => {
                            return (
                                <>
                                    <tr className="trans">
                                        <td>{trans.to}</td>
                                        <td>{trans.from}</td>
                                        <td>{trans.amount}</td>
                                    </tr>
                                </>
                            )
                        })
                        }
                    </tbody>
                </table>

            </div>
        </>
    )
}

export default Transaction;